export default "__VITE_ASSET__DUg1$4fa__"